import { SET_WORKSPACE_SETTINGS_SETTINGS } from 'actions'
import randomId from 'random-id'
import createSettingsReducer from '../utils/create-settings-reducer'

const notificationsTabs = [
  { name: 'Sources', id: randomId() },
  { name: 'Warehouses', id: randomId() },
  { name: 'Integrations', id: randomId() }
]

export default createSettingsReducer(SET_WORKSPACE_SETTINGS_SETTINGS, {
  notificationsTabs,
  activeNotificationsTab: notificationsTabs[0],
  isSavingNotificationSettings: false,
  showRemoveOwnerConfirm: false,
  isDeletingWorkspace: false,
  isRemovingUser: false,
  isInvitingUser: false,
  teamInviteEmailAddress: '',
  userEmailToRemove: '',
  isChangingCreditCard: false,
  mtuCount: 10000,
  isChangingSubscription: false,
  transactionFailed: false,
  showAuthenticationSetup: false,
  isRemoveDomainDialogVisible: false,
  deleteError: null
})
